// extracted by mini-css-extract-plugin
module.exports = {"tablaEmergencias":"Emergency_tablaEmergencias__39qk1"};